const state = {
  form: {
    search: null,
  },
  status: null,
  details: {
    pages: [],
  },
};

export default state;
